import secureLocalStorage from "react-secure-storage";

// A login that required picking a branch (multiple active v_suc rows) is
// single-session only: closing or reloading the page must force a fresh
// login - and a fresh branch pick - rather than silently resuming. This is
// deliberately a separate listener from handleUnload/handleBeforeUnload
// (which also fire on mere tab visibility changes via handleVisibilityChange)
// so switching tabs or minimizing the window never signs the user out.
// directReload() removes this listener before any trusted, app-triggered
// reload (branch switch, quick-login), so only a genuine user-initiated
// close/refresh reaches this.
export const clearSessionOnExit = () => {
  if (secureLocalStorage.getItem("branchSelectedAtLogin")) {
    secureLocalStorage.removeItem("token");
    secureLocalStorage.removeItem("branch");
    secureLocalStorage.removeItem("branchSelectedAtLogin");
  }
};

export const handleUnload = () => {
  // if (activeDocuments.length > 0) {
  //   navigator.sendBeacon(
  //     `${mainConfig.url}/saveTempDocs.php`,
  //     JSON.stringify(activeDocuments)
  //   );
  // }
};

export const handleVisibilityChange = () => {
  if (document.visibilityState === "hidden") {
    handleUnload();
  }
};

export const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  // const data = getData();
  // if (data) {
  // Mostrar advertencia al salir
  event.preventDefault();
  event.returnValue = "";
  // }
};
